import getScrollbarWidth from '../helpers/scrollbar-width';

class MenuToggle {
  constructor(options = {}) {
    this.config = {
      rootModule: document.querySelector('[data-module="Header"]'),
      module: document.querySelector('[data-module="MenuToggle"]'),
      menuModals: document.querySelectorAll('[data-module="MenuModal"]'),
      modalTriggers: document.querySelectorAll('[href^="#menuModal="]'),
      ...options
    };
  }

  init() {
    const { module, modalTriggers } = this.config;

    if (!module) {
      return;
    }

    module.addEventListener('click', this.toggleMenu.bind(this));
    window.addEventListener('resize', this.reset.bind(this));

    modalTriggers.forEach(trigger =>
      trigger.addEventListener('click', this.triggerModal.bind(this))
    );
  }

  destroy() {
    const { module, modalTriggers } = this.config;

    this.reset();
    module.removeEventListener('click', this.toggleMenu.bind(this));
    window.removeEventListener('resize', this.reset.bind(this));

    modalTriggers.forEach(trigger =>
      trigger.removeEventListener('click', this.triggerModal.bind(this))
    );
  }

  toggleAnimationState() {
    this.isAnimating = !this.isAnimating;
  }

  toggleMenu(e) {
    e.preventDefault();
    this.toggle('menu', e.currentTarget.classList.contains('is-open'));
  }

  triggerModal(e) {
    const modalId = e.currentTarget.getAttribute('href').split('#menuModal=')[1];
    e.preventDefault();
    this.toggle(modalId);
  }

  async toggle(modalId, forceClose) {
    const { menuModals } = this.config;
    const modalList = Array.from(menuModals);
    const menuModal = modalList.find(modal => modal.dataset.modalId === modalId);
    const openModal = modalList.find(modal => !!modal.classList.contains('is-open'));

    if (this.isAnimating || !menuModal) {
      return;
    }

    if (forceClose) {
      this.animateModal(openModal);
    } else if (openModal && openModal !== menuModal) {
      await this.animateModal(openModal);
      this.animateModal(menuModal);
    } else {
      this.animateModal(menuModal);
    }
  }

  animateModal(menuModal) {
    const { module } = this.config;

    return new Promise(resolve => {
      this.toggleAnimationState();
      menuModal.classList.toggle('is-open');

      if (module.classList.contains('is-open')) {
        module.classList.replace('is-open', 'is-half-open');
        setTimeout(() => {
          module.classList.remove('is-half-open');
          document.body.style.paddingRight = '';
          document.body.style.overflow = '';
        }, 250);
      } else {
        module.classList.add('is-half-open');
        setTimeout(() => {
          module.classList.replace('is-half-open', 'is-open');
          document.body.style.paddingRight = `${getScrollbarWidth()}px`;
          document.body.style.overflow = 'hidden';
        }, 250);
      }

      setTimeout(() => {
        this.toggleAnimationState();
        resolve();
      }, 500);
    });
  }

  reset() {
    const { module, menuModals } = this.config;

    [module, ...menuModals].forEach(el => el.classList.remove('is-open'));
    document.body.style.paddingRight = '';
    document.body.style.overflow = '';
  }
}

export default MenuToggle;
